import React from 'react';
import { createRoot } from 'react-dom/client';

import eventEmitter, { EventsTypes } from '@Ui/js/services/events/eventEmitter';

import SearchForm from 'common/components/ui/SearchForm';

const FOCUS_DELAY_MS = 100;

function focusHeaderSearchInput() {
  const input = document.getElementById('header-search-input');
  if (input instanceof HTMLInputElement) {
    input.focus();
  }
}

export default function initHeaderSearch() {
  const anchor = document.getElementById('search-engine');
  if (anchor) {
    const input = document.getElementById(
      'header-search-input'
    ) as HTMLInputElement | null;
    const hasFocus = input === document.activeElement;
    const value = input?.value;
    const root = createRoot(anchor);
    root.render(
      <SearchForm
        initialValue={value}
        withFocus={hasFocus}
        inputId="header-search-input"
        context="header"
      />
    );

    eventEmitter.on(EventsTypes.SEARCH_OPEN, () => {
      setTimeout(focusHeaderSearchInput, FOCUS_DELAY_MS);
    });
  }
}
